<p-table #companyTable [value]="loading ? [] : companies" styleClass="user-directory-company-table"
  [globalFilterFields]="['tenant', 'rs2CompanyNo', 'shortName', 'name', 'address.streetAddress', 'address.zipCode', 'address.city', 'address.country']"
  [resizableColumns]="true" columnResizeMode="expand" [scrollable]="true"
  [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20]"
  [currentPageReportTemplate]="'primeng.currentPageReportTemplate' | translate" [showCurrentPageReport]="true"
  [loading]="loading" [showLoader]="false" (onFilter)="onFilter($event)">
  <ng-template #caption>
    <div class="grid lg:grid-cols-2 grid-cols-1 md:text-base text-sm">
      <div class="col-span-1 my-auto md:mx-0 mb-3">
        <p class="font-['Apex_Rounded_Medium'] text-sm">
          {{ captionKey | translate }}
        </p>
      </div>
      <div class="col-span-1">
        <div class="flex flex-col sm:flex-row items-stretch sm:items-center justify-center sm:justify-end gap-2">
          @if (hasActiveFilterOrSearch()) {
            <p-button [label]="'clearFilter' | translate" severity="danger" icon="pi pi-filter-slash"
              (onClick)="clearFilters(companyTable)" styleClass="w-full sm:w-auto text-sm md:text-base" />
          }
          <p-iconfield iconPosition="left" class="w-full sm:w-80">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input pInputText type="text" [placeholder]="'userAdministration.companySearchPlaceholder' | translate"
              [ngModel]="globalFilterValue"
              (ngModelChange)="onGlobalFilterChange($event, companyTable)"
              class="md:text-base text-sm w-full" />
          </p-iconfield>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      @if (selectable) {
        <th class="col-toggle-select" pFrozenColumn>
          <p-checkbox [binary]="true" [ngModel]="areAllCompaniesSelected()"
            (onChange)="onToggleAll(!!$event.checked)" />
        </th>
      }
      <th pResizableColumn pSortableColumn="tenant">
        {{ "userAdministration.tenant" | translate }}
        <p-sortIcon field="tenant" />
        <p-columnFilter type="text" field="tenant" display="menu" [showOperator]="false"
          [showMatchModes]="false" [showAddButton]="false" [hideOnClear]="true">
          <ng-template #filtericon let-hasFilter="hasFilter">
            <gate-table-filter-icon [hasFilter]="hasFilter" [table]="companyTable" field="tenant" />
          </ng-template>
        </p-columnFilter>
      </th>
      <th pResizableColumn pSortableColumn="rs2CompanyNo">
        {{ "userAdministration.customerNumber" | translate }}
        <p-sortIcon field="rs2CompanyNo" />
        <p-columnFilter type="text" field="rs2CompanyNo" display="menu" [showOperator]="false"
          [showMatchModes]="false" [showAddButton]="false" [hideOnClear]="true">
          <ng-template #filtericon let-hasFilter="hasFilter">
            <gate-table-filter-icon [hasFilter]="hasFilter" [table]="companyTable" field="rs2CompanyNo" />
          </ng-template>
        </p-columnFilter>
      </th>
      <th pResizableColumn pSortableColumn="shortName">
        {{ "userAdministration.shortName" | translate }}
        <p-sortIcon field="shortName" />
        <p-columnFilter type="text" field="shortName" display="menu" [showOperator]="false"
          [showMatchModes]="false" [showAddButton]="false" [hideOnClear]="true">
          <ng-template #filtericon let-hasFilter="hasFilter">
            <gate-table-filter-icon [hasFilter]="hasFilter" [table]="companyTable" field="shortName" />
          </ng-template>
        </p-columnFilter>
      </th>
      <th pResizableColumn pSortableColumn="name">
        {{ addressHeaderKey | translate }}
        <p-sortIcon field="name" />
        <p-columnFilter type="text" field="name" display="menu" [showOperator]="false"
          [showMatchModes]="false" [showAddButton]="false" [hideOnClear]="true">
          <ng-template #filtericon let-hasFilter="hasFilter">
            <gate-table-filter-icon [hasFilter]="hasFilter" [table]="companyTable" field="name" />
          </ng-template>
        </p-columnFilter>
      </th>
      @if (showGroupSelection) {
        <th pResizableColumn>{{ "userAdministration.selectGroups" | translate }}</th>
      }
      @if (showImpersonation || showApplyAction) {
        <th pResizableColumn pFrozenColumn alignFrozen="right"></th>
      }
    </tr>
  </ng-template>

  <ng-template #body let-company>
    <tr [class.child-row]="company.isHierarchyChild && isModuleAdmin">
      @if (selectable) {
        <td class="action-td col-toggle-select" pFrozenColumn>
          <p-checkbox [binary]="true" [(ngModel)]="selectedCompanies[company.rs2CompanyNo]"
            (onChange)="onCompanySelectionChange(company)" />
        </td>
      }
      <td>
        <span class="p-column-title">{{ "userAdministration.tenant" | translate }}</span>
        <span>{{ company.tenant }}</span>
      </td>
      <td>
        <span class="p-column-title">{{ "userAdministration.customerNumber" | translate }}</span>
        <span>{{ company.rs2CompanyNo }}</span>
      </td>
      <td>
        <span class="p-column-title">{{ "userAdministration.shortName" | translate }}</span>
        <span class="table-col-primary" [title]="getShortName(company)">{{ getShortName(company) }}</span>
      </td>
      <td>
        <span class="p-column-title">{{ addressHeaderKey | translate }}</span>
        <span [title]="getAddressTitle(company)">
          <span>{{ company.name }}</span>
          @if (company.address.streetAddress) {
            <br />{{ company.address.streetAddress }}
          }
          @if (company.address.zipCode || company.address.city || company.address.country) {
            <br />
            @if (company.address.zipCode) {{{ company.address.zipCode }} }
            @if (company.address.city) {<strong>{{ company.address.city }}</strong>}
            @if (company.address.country) {,{{ company.address.country }}}
          }
        </span>
      </td>
      @if (showGroupSelection) {
        <td>
          <span class="p-column-title">{{ "userAdministration.selectGroups" | translate }}</span>
          @if ((company.securityGroups?.length ?? 0) > 0) {
            @if (groupSelectionMode === 'single') {
              <p-select [options]="company.securityGroups || []" optionLabel="groupName"
                [ngModel]="getSelectedGroup(company)"
                (onChange)="onSingleGroupSelectionChange(company, $event.value)"
                [placeholder]="'kam.userImport.selectGroup' | translate" appendTo="body"
                class="w-full" [disabled]="!selectedCompanies[company.rs2CompanyNo]" />
            } @else {
              <p-multiSelect #groupsMultiSelect [options]="company.securityGroups || []" optionLabel="groupName"
                [(ngModel)]="selectedGroups[company.rs2CompanyNo]"
                (onChange)="onGroupSelectionChange(company, $event.value)"
                [placeholder]="'kam.userImport.selectGroup' | translate" appendTo="body"
                panelStyleClass="gate-multiselect-panel--responsive"
                [showToggleAll]="true" [showHeader]="false" class="w-full"
                [disabled]="!selectedCompanies[company.rs2CompanyNo]">
                <ng-template #header>
                  <div class="flex flex-col gap-2 pt-2 pb-3 px-4 border-b border-[var(--border-color)]">
                    <p-iconfield iconPosition="left" class="w-full">
                      <p-inputicon>
                        <i class="pi pi-search"></i>
                      </p-inputicon>
                      <input pInputText type="text" [placeholder]="'searchPlaceholder' | translate"
                        (input)="groupsMultiSelect.onFilterInputChange($event)" class="w-full" />
                    </p-iconfield>
                    <div class="flex items-center justify-between gap-2">
                      <div class="flex items-center gap-2">
                        <p-checkbox [binary]="true" [ngModel]="groupsMultiSelect.allSelected()"
                          (onChange)="groupsMultiSelect.onToggleAll($event)" />
                        <span>{{ "kam.moduleManagement.selectAll" | translate }}</span>
                      </div>
                      <span class="claim-selected-count">
                        {{ "kam.moduleManagement.selectedCount" | translate: { count: selectedGroups[company.rs2CompanyNo]?.length || 0 } }}
                      </span>
                    </div>
                  </div>
                </ng-template>
              </p-multiSelect>
            }
          } @else {
            <span>-</span>
          }
        </td>
      }
      @if (showImpersonation || showApplyAction) {
        <td class="action-td" pFrozenColumn alignFrozen="right">
          @if (showImpersonation && company.canImpersonate) {
            <p-button class="flex-1" size="small" styleClass="btn-impersonate !h-[28px] w-full"
              [loading]="company.isImpersonating" (onClick)="impersonate.emit(company)">
              {{ "kam.customerAdministration.actionImpersonate" | translate }}
            </p-button>
          }
          @if (showApplyAction) {
            <p-button class="flex-1" size="small" styleClass="btn-impersonate !h-[30px] w-full"
              (onClick)="applyCompany.emit(company)">
              {{ "userAdministration.apply" | translate }}
            </p-button>
          }
        </td>
      }
    </tr>
  </ng-template>

  <ng-template #loadingbody>
    @for (i of [1,2,3,4,5]; track i) {
      <tr>
        @if (selectable) {
          <td><p-skeleton width="1.25rem" height="1.25rem"></p-skeleton></td>
        }
        <td><p-skeleton width="80%" height="1rem"></p-skeleton></td>
        <td><p-skeleton width="70%" height="1rem"></p-skeleton></td>
        <td><p-skeleton width="85%" height="1rem"></p-skeleton></td>
        <td><p-skeleton width="90%" height="1rem"></p-skeleton></td>
        @if (showGroupSelection) {
          <td><p-skeleton width="100%" height="2rem"></p-skeleton></td>
        }
        @if (showImpersonation || showApplyAction) {
          <td class="action-td"><p-skeleton width="6rem" height="1.5rem"></p-skeleton></td>
        }
      </tr>
    }
  </ng-template>

  <ng-template #emptymessage>
    <tr class="emptymessage">
      <td [attr.colspan]="4 + (selectable ? 1 : 0) + (showGroupSelection ? 1 : 0) + ((showImpersonation || showApplyAction) ? 1 : 0)">
        {{ emptyMessageKey | translate }}
      </td>
    </tr>
  </ng-template>
</p-table>
